module.exports = __webpack_public_path__ + "static/img/walking-man-white.93312f9.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/svg/walking-man-white.svg
// module id = UUXo
// module chunks = 74